


















import { defineComponent, computed } from '@nuxtjs/composition-api'

// Types
import { SearchResultsObjectInterface } from '@/types/search/searchTypes'
import { SupportResultsObjectInterface } from '@/types/support/knowledgeBaseTypes'

export default defineComponent({
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    results: {
      type: Object as () => SearchResultsObjectInterface | SupportResultsObjectInterface,
      required: true,
    },
  },
  emits: ['onPaginationClick'],
  setup(props) {
    // Figure out if we need to show/hide the last button
    const showLastPaginationButton = computed(() => {
      return (
        props.results.meta?.page?.total_pages &&
        props.results.meta.page.total_results !== undefined &&
        props.currentPage < props.results.meta.page.total_pages
      )
    })

    // Calculate the needed array for pagination
    const numbersArray = computed(() => {
      // vars
      const totalPages = props.results.meta?.page?.total_pages !== undefined ? props.results.meta.page.total_pages : 1
      const nrArray: Array<number> = [props.currentPage]

      // Add numbers before
      if (props.currentPage === 2) {
        nrArray.unshift(1)
      } else if (props.currentPage > 2) {
        nrArray.unshift(props.currentPage - 2, props.currentPage - 1)
      }

      // add numbers after
      if (props.currentPage < totalPages) {
        // add one directly after currentPage
        nrArray.push(props.currentPage + 1)

        // check for second
        if (props.currentPage + 2 <= totalPages) {
          nrArray.push(props.currentPage + 2)
        }
      }

      return nrArray
    })

    return {
      numbersArray,
      showLastPaginationButton,
    }
  },
})
